<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="close()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="verifica-tu-cuenta"> {{ $t("login.verifucaCuenta") }}  </h1>
              <p class="py-5 su-cuenta-se-ha-crea">
                {{ $t("login.sucuentaseha") }}
                <br />{{ $t("login.debeconsultar") }} <br />{{ $t("login.acceder") }} 
                
              </p>
              <v-row> </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>

        <v-btn
          dark
          depressed
          :color="entityConfig.primaryColor"
          class="float-end m-2 rectangle-button-2"
             :style="`color: ${entityConfig.secondaryColor}`"
          @click="close()"
        >
         {{ $t("login.entendido") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
@import "../login/login.style";
</style>

<script>
export default {
  props: ["visible"],
  data() {
    return {
      entityConfig: {},
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    this.codNrbeEn = sessionStorage.getItem("codNrbeEn");
  },

  methods: {
    close() {
      this.$emit("closed");
    },
    save(data) {
      this.$emit("saved", data);      
    },
  },
};
</script>
